import { CONTEXT } from '../config/consts/commons';

import { COUNTRIES_REGIONAL_CONFIG } from '@wareclouds/frontend-common';

function NumberFormatUnit({ value, unit = 'kilometer' }) {
  const { countryCode } = COUNTRIES_REGIONAL_CONFIG[CONTEXT];

  return new Intl.NumberFormat(countryCode, {
    style: 'unit',
    unit,
    maximumFractionDigits: 1,
  }).format(value);
}

export default NumberFormatUnit;
